import React, { useEffect, useRef, useState } from "react";

import { abrirArchivo } from "../../../components/enrollment/visorArchivo";
import {
	AjustesPortal, ArchivoNuevo, ArchivoPublicacion, AutorPortal, ComentarioPortal, PortalApi, PortalApiAlumno, PortalApiPersonal,
	PublicacionPortal, UnidadPortal
} from "../../../services/v2/classPortal.service";
import { BloqueEncuestaVista, cerrarEncuesta } from "./quiz/encuesta";
import "./portalClase.css";

/*
	Piezas que comparten la pantalla del personal y la del alumno (Portal de Clase, Parte A). Los archivos nunca son públicos:
	se abren en el visor de WAPP con un enlace firmado de 10 min que pide el servidor (nada de window.open con blob).
*/

export const mensajeDeError = (e: any, porOmision = "No pudimos hacerlo. Intenta otra vez en un momento."): string =>
	e?.response?.data?.message || porOmision

/** Mensaje de una pantalla: lo que salió bien va en el color normal del texto; solo avisos y errores van en oro. */
export interface Aviso { texto: string; oro: boolean }
export const exito = (texto: string): Aviso => ({ texto, oro: false })
export const problema = (texto: string): Aviso => ({ texto, oro: true })
export const LineaAviso: React.FC<{ a: Aviso | null; style?: React.CSSProperties }> = ({ a, style }) =>
	a ? <div className="pcAviso" role={a.oro ? "alert" : "status"} style={{ color: a.oro ? "var(--pc-oro-texto)" : "var(--pc-tinta)", ...style }}>{a.texto}</div> : null

const Svg: React.FC<{ d: string; size?: number; sw?: number }> = ({ d, size = 18, sw = 1.8 }) => (
	<svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round"><path d={d} /></svg>
)
export const ICONOS = {
	ojo: "M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z",
	burbuja: "M4 5h16v11H9l-5 4z",
	pin: "M12 17v5M9 3h6l-1 6 3 3v2H7v-2l3-3z",
	doc: "M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8zM14 3v5h5",
	enlace: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
	megafono: "M3 11v2a1 1 0 0 0 1 1h3l6 4V6L7 10H4a1 1 0 0 0-1 1zM17 9a4 4 0 0 1 0 6",
	puntos: "M5 12h.01M12 12h.01M19 12h.01",
	cerrar: "M6 6l12 12M18 6L6 18",
	atras: "M15 5l-7 7 7 7",
	casa: "M3 11l9-7 9 7v9H3z",
	lugar: "M12 21s7-6 7-12a7 7 0 0 0-14 0c0 6 7 12 7 12zM12 6.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z",
	video: "M3 8a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM15 10l6-3v10l-6-3",
	foto: "M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM8 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM21 16l-5-5-8 8",
	sliders: "M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12",
	clip: "M21 12l-8.5 8.5a5 5 0 0 1-7-7L14 5a3.5 3.5 0 0 1 5 5l-8.5 8.5a2 2 0 0 1-3-3L15 7",
	check: "M5 12l4 4 10-10",
	camara: "M4 8h3l2-3h6l2 3h3v11H4zM12 10a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z",
	pregunta: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9.5 9.5a2.5 2.5 0 1 1 3 2.4c-.6.2-.5.8-.5 1.6M12 17h.01",
	mas: "M12 5v14M5 12h14",
	lapiz: "M4 20h4L19 9l-4-4L4 16zM13 7l4 4",
	ampliar: "M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5",
	barras: "M5 20V10M12 20V4M19 20v-7",
	copiar: "M8 8h11v13H8zM5 16H4V3h11v1",
	basura: "M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13",
	arriba: "M12 19V5M5 12l7-7 7 7",
	abajo: "M12 5v14M5 12l7 7 7-7",
	reloj: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2",
	encuesta: "M4 6h11M4 12h16M4 18h7",
}
export const Icono: React.FC<{ n: keyof typeof ICONOS; size?: number }> = ({ n, size }) => <Svg d={ICONOS[n]} size={size} />

export const Avatar: React.FC<{ a: { name: string; initials: string; photo: string | null; isTeacher?: boolean }; size?: number }> = ({ a, size = 40 }) => (
	<span className={"pcAv" + (a.isTeacher ? " pcAvMaestro" : "")} style={{ width: size, height: size, fontSize: Math.round(size * 0.35) }} aria-hidden="true">
		{a.photo ? <img src={a.photo} alt="" /> : a.initials}
	</span>
)

// ---------------------------------------------------------------- portada

export const PatronSvg: React.FC<{ patron: AjustesPortal["coverPattern"]; chico?: boolean }> = ({ patron, chico }) => {
	const id = "pcp" + (chico ? "c" : "g")
	if (patron === "liso") return null
	return (
		<svg className="pcPatron" aria-hidden="true">
			<defs>
				{patron === "circ"
					? <pattern id={id} width={chico ? 32 : 44} height={chico ? 32 : 44} patternUnits="userSpaceOnUse"><circle cx={chico ? 16 : 22} cy={chico ? 16 : 22} r={chico ? 6 : 9} fill="none" stroke="#fff" strokeOpacity=".15" strokeWidth="2" /></pattern>
					: <pattern id={id} width="18" height="18" patternUnits="userSpaceOnUse" patternTransform="rotate(35)"><path d="M0 0v18" stroke="#fff" strokeOpacity=".14" strokeWidth="3" /></pattern>}
			</defs>
			<rect width="100%" height="100%" fill={"url(#" + id + ")"} />
			{!chico && patron === "circ" ? <circle cx="92%" cy="10%" r="150" fill="#fff" fillOpacity=".08" /> : null}
		</svg>
	)
}

export const fondoDePortada = (a: AjustesPortal): React.CSSProperties =>
	a.coverPhotoUrl ? { backgroundColor: a.coverColor, backgroundImage: "url(" + a.coverPhotoUrl + ")" } : { background: a.coverColor }

// ---------------------------------------------------------------- archivos

export const tamanoLegible = (n: number): string =>
	n >= 1048576 ? (n / 1048576).toFixed(1).replace(/\.0$/, "") + " MB" : n >= 1024 ? Math.round(n / 1024) + " KB" : n + " B"

export const abrirAdjunto = (api: PortalApi, f: ArchivoPublicacion, esAlumno: boolean): void => {
	const url = async () => (await api.fileUrl(f.id)).url
	abrirArchivo({
		nombre: f.name, mime: f.mime, origen: "Portal de Clase", descargar: esAlumno ? false : undefined,
		obtenerUrl: url,
		cargar: async () => {
			const r = await fetch(await url())
			if (!r.ok) throw new Error("No se pudo leer el archivo")
			return { blob: await r.blob(), nombre: f.name }
		}
	})
}

export const ArchivosDeLaPublicacion: React.FC<{ api: PortalApi; archivos: ArchivoPublicacion[]; esAlumno: boolean }> = ({ api, archivos, esAlumno }) => {
	if (archivos.length === 0) return null
	return (
		<div className="pcArchivos">
			{archivos.map((f) => f.kind === "enlace"
				? <a key={f.id} className="pcArchivo" href={f.url || "#"} target="_blank" rel="noopener noreferrer"><Icono n="enlace" /><span className="pcNombre">{f.name}</span></a>
				: <button key={f.id} type="button" className="pcArchivo" onClick={() => abrirAdjunto(api, f, esAlumno)}>
					<Icono n="doc" /><span className="pcNombre">{f.name}</span>{f.size ? <small>{tamanoLegible(f.size)}</small> : null}
				</button>)}
		</div>
	)
}

/** Reduce una foto a 1600 px por el lado largo y la pasa a JPEG (la portada y, luego, las entregas desde el celular). */
export const reducirImagen = (archivo: File, maximo = 1600): Promise<File> => new Promise((resolve) => {
	if (!/^image\/(jpeg|png|webp)$/i.test(archivo.type)) { resolve(archivo); return }
	const url = URL.createObjectURL(archivo)
	const img = new Image()
	img.onload = () => {
		URL.revokeObjectURL(url)
		const escala = Math.min(1, maximo / Math.max(img.width, img.height))
		if (escala === 1 && archivo.type === "image/jpeg") { resolve(archivo); return }
		const lienzo = document.createElement("canvas")
		lienzo.width = Math.round(img.width * escala)
		lienzo.height = Math.round(img.height * escala)
		const ctx = lienzo.getContext("2d")
		if (!ctx) { resolve(archivo); return }
		ctx.drawImage(img, 0, 0, lienzo.width, lienzo.height)
		lienzo.toBlob((b) => resolve(b ? new File([b], archivo.name.replace(/\.\w+$/, "") + ".jpg", { type: "image/jpeg" }) : archivo), "image/jpeg", 0.85)
	}
	img.onerror = () => { URL.revokeObjectURL(url); resolve(archivo) }
	img.src = url
})

/** Sube un archivo directo a Spaces con el boleto (URL firmada, PUT) y avisa el avance. Devuelve la llave guardada. */
export const subirConBoleto = async (pedirBoleto: (tipo: string) => Promise<{ key: string; url: string }>, archivo: File, avance?: (porciento: number) => void): Promise<string> => {
	const tipo = archivo.type || "application/octet-stream"
	const boleto = await pedirBoleto(tipo)
	await new Promise<void>((resolve, reject) => {
		const x = new XMLHttpRequest()
		x.open("PUT", boleto.url)
		x.setRequestHeader("Content-Type", tipo)
		x.upload.onprogress = (e) => { if (e.lengthComputable && avance) avance(Math.round((e.loaded / e.total) * 100)) }
		x.onload = () => (x.status >= 200 && x.status < 300 ? resolve() : reject(new Error("No se pudo subir el archivo.")))
		x.onerror = () => reject(new Error("No se pudo subir el archivo."))
		x.send(archivo)
	})
	return boleto.key
}

export const subirArchivo = (api: PortalApiPersonal, archivo: File, purpose: "adjunto" | "portada", avance?: (porciento: number) => void): Promise<string> =>
	subirConBoleto((tipo) => api.uploadUrl({ name: archivo.name, size: archivo.size, mime: tipo, purpose }), archivo, avance)

const MESES_CORTOS = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"]

/** "2026-11-10" → "10 Nov" (with the year when it isn't this year). */
export const fechaCorta = (ymd: string): string => {
	const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(ymd)
	if (!m) return ymd
	const anio = Number(m[1]) !== new Date().getFullYear() ? " " + m[1] : ""
	return Number(m[3]) + " " + MESES_CORTOS[Number(m[2]) - 1] + anio
}

/** "2026-10-20T19:30" en hora de la Ciudad de México, para el campo datetime-local. */
export const aCampoFecha = (ms: number): string => {
	const p = new Intl.DateTimeFormat("en-CA", { timeZone: "America/Mexico_City", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(new Date(ms))
	const v = (t: string) => p.find((x) => x.type === t)?.value ?? ""
	return `${v("year")}-${v("month")}-${v("day")}T${v("hour")}:${v("minute")}`
}

/** Recarga cuando se vuelve a ver la pestaña (sin sondeos). */
export const useAlVolver = (recargar: () => void, minimoMs = 30000): void => {
	const ultima = useRef<number>(Date.now())
	useEffect(() => {
		const alVolver = () => {
			if (document.visibilityState === "visible" && Date.now() - ultima.current >= minimoMs) { ultima.current = Date.now(); recargar() }
		}
		document.addEventListener("visibilitychange", alVolver)
		return () => document.removeEventListener("visibilitychange", alVolver)
	}, [recargar, minimoMs])
}

// ---------------------------------------------------------------- comentarios y publicación

const UnComentario: React.FC<{ c: ComentarioPortal; onBorrar?: () => void }> = ({ c, onBorrar }) => (
	<div className="pcComentario">
		<Avatar a={c.author} size={30} />
		<div className="pcComentarioTexto"><b>{c.author.name}</b> <span className="pcTenue">{c.whenLabel}</span><br />{c.body}</div>
		{onBorrar && c.canDelete ? <button type="button" className="pcIb" style={{ width: 36, height: 36 }} aria-label="Borrar comentario" onClick={onBorrar}><Icono n="cerrar" size={16} /></button> : null}
	</div>
)

interface PropsPublicacion
{
	api: PortalApi
	post: PublicacionPortal
	esAlumno: boolean
	puedeComentar: boolean
	onCambio: (p: PublicacionPortal) => void
	onQuitar: (id: number) => void
	onEditar?: (p: PublicacionPortal) => void
	onFijar?: (p: PublicacionPortal) => void
	/** Material: en la lista agrupada va más compacto. */
	compacta?: boolean
	/** Tareas: abre la tarea (personal: Calificar; alumno: su pantalla de entrega). */
	onAbrirTarea?: (p: PublicacionPortal) => void
}

export const TarjetaPublicacion: React.FC<PropsPublicacion> = ({ api, post, esAlumno, puedeComentar, onCambio, onQuitar, onEditar, onFijar, compacta, onAbrirTarea }) => {
	const [todos, setTodos] = useState<ComentarioPortal[] | null>(null)
	const [abierto, setAbierto] = useState<boolean>(false)
	const [texto, setTexto] = useState<string>("")
	const [ocupado, setOcupado] = useState<boolean>(false)
	const [error, setError] = useState<string | null>(null)
	const [menu, setMenu] = useState<boolean>(false)
	const menuRef = useRef<HTMLDivElement>(null)
	//The ⋯ menu closes on a click outside it or with Esc (QA B3).
	useEffect(() => {
		if (!menu) return
		const fuera = (e: MouseEvent) => { if (menuRef.current && !menuRef.current.contains(e.target as Node)) setMenu(false) }
		const esc = (e: KeyboardEvent) => { if (e.key === "Escape") setMenu(false) }
		document.addEventListener("mousedown", fuera)
		document.addEventListener("keydown", esc)
		return () => { document.removeEventListener("mousedown", fuera); document.removeEventListener("keydown", esc) }
	}, [menu])

	const aplicar = (lista: ComentarioPortal[]) => {
		setTodos(lista)
		onCambio({ ...post, commentsCount: lista.length, lastComments: lista.slice(-2) })
	}
	const verTodos = async () => {
		setAbierto(true)
		if (todos === null) { try { setTodos(await api.comments(post.id)) } catch (e) { setError(mensajeDeError(e)) } }
	}
	const enviar = async () => {
		const t = texto.trim()
		if (!t || ocupado) return
		setOcupado(true); setError(null)
		try { aplicar(await api.addComment(post.id, t)); setTexto(""); setAbierto(true) } catch (e) { setError(mensajeDeError(e)) } finally { setOcupado(false) }
	}
	const borrarComentario = async (id: number) => {
		if (!window.confirm("¿Borrar este comentario?")) return
		try { aplicar(await api.deleteComment(post.id, id)) } catch (e) { setError(mensajeDeError(e)) }
	}
	const borrar = async () => {
		setMenu(false)
		if (!window.confirm("¿Borrar esta publicación?")) return
		try { await api.deletePost(post.id); onQuitar(post.id) } catch (e) { setError(mensajeDeError(e)) }
	}

	const lista = abierto && todos !== null ? todos : post.lastComments
	const esMaterial = post.type === "material"
	const esTarea = post.type === "tarea"
	const esPendiente = post.type === "pendiente"
	const esEncuesta = post.type === "encuesta"
	const conIcono = esMaterial || esTarea || esPendiente || esEncuesta
	const tipoTexto = esMaterial ? "Material" : esTarea ? (post.assignment?.delivery === "quiz" ? "Quiz" : "Tarea") : esEncuesta ? "Encuesta" : "Pendiente"
	const cerrarOAbrir = async () => {
		setMenu(false)
		if (!post.poll) return
		const reabrir = post.poll.closed
		try {
			const p = await cerrarEncuesta(api as PortalApiPersonal, post, !reabrir)
			onCambio(p)
			//Reopened with no close date left (it had closed on its own date): say so instead of leaving it open forever silently.
			if (reabrir && p.poll && !p.poll.closesMs) setError("Encuesta reabierta sin fecha de cierre. Si quieres que cierre sola, ponle una fecha en Editar.")
		} catch (e) { setError(mensajeDeError(e)) }
	}
	const marcar = (api as PortalApiAlumno).checkTodo
	const hecho = esAlumno && esPendiente && post.todo?.done === true
	const alternar = async () => {
		if (!marcar || ocupado) return
		setOcupado(true); setError(null)
		try { onCambio({ ...(await marcar(post.id, !hecho)) }) } catch (e) { setError(mensajeDeError(e)) } finally { setOcupado(false) }
	}
	const ficha = post.assignment
	return (
		<article className={"pcTarjeta" + (post.pinned ? " pcFijada" : "")} style={compacta ? { padding: 14 } : undefined}>
			<div className="pcFilaAutor">
				{conIcono
					? <span className="pcAv" style={{ width: 40, height: 40, borderRadius: 12, background: esTarea || esEncuesta ? "var(--pc-acento-tinte)" : "var(--pc-chip)", color: esTarea || esEncuesta ? "var(--pc-acento-texto)" : "var(--pc-tinta)" }} aria-hidden="true"><Icono n={esMaterial ? "doc" : esTarea ? (post.assignment?.delivery === "quiz" ? "pregunta" : "clip") : esEncuesta ? "encuesta" : "check"} size={20} /></span>
					: <Avatar a={post.author} />}
				<div className="pcAutorTextos">
					<div className="pcAutorNombre">{conIcono ? <>{tipoTexto} <span className="pcTenue" style={{ fontWeight: 500 }}>{post.unit?.name ? "· " + post.unit.name : ""}</span></> : post.author.name}</div>
					<div className="pcTenue pcChico">{post.whenLabel}{conIcono ? " · " + post.author.name : ""}</div>
				</div>
				{!esAlumno && post.originLabel && (post.inherited || conIcono) ? <span className="pcChip pcChipBorde">{post.originLabel}</span> : null}
				{!esAlumno && post.changedHere ? <span className="pcChip pcChipAcento">Cambiada Aquí</span> : null}
				{!esAlumno && post.retired ? <span className="pcChip pcChipOro">Retirada Del Curso</span> : null}
				{post.isNew ? <span className="pcChip pcChipAcento"><span className="pcNuevo" />Nuevo</span> : null}
				{post.status === "programada" ? <span className="pcChip pcChipOro">Programada</span> : null}
				{post.status === "borrador" ? <span className="pcChip pcChipOro">Borrador</span> : null}
				{post.pinned ? <span className="pcChip pcChipAcento"><Icono n="pin" size={14} />Fijado</span> : null}
				{post.canEdit ? (
					<div className="pcMenu" ref={menuRef}>
						<button type="button" className="pcIb" aria-label="Opciones" aria-expanded={menu} onClick={() => setMenu(!menu)}><Icono n="puntos" /></button>
						{menu ? (
							<div className="pcMenuLista" role="menu">
								{onFijar ? <button type="button" role="menuitem" onClick={() => { setMenu(false); onFijar(post) }}>{post.pinned ? "Quitar Fijado" : "Fijar"}</button> : null}
								{onEditar && !post.inherited ? <button type="button" role="menuitem" onClick={() => { setMenu(false); onEditar(post) }}>Editar</button> : null}
								{esEncuesta && !esAlumno && post.poll && post.status === "publicada" ? <button type="button" role="menuitem" onClick={cerrarOAbrir}>{post.poll.closed ? "Reabrir Encuesta" : "Cerrar Encuesta"}</button> : null}
								{!post.inherited ? <button type="button" role="menuitem" onClick={borrar}>Borrar</button> : null}
							</div>
						) : null}
					</div>
				) : null}
			</div>
			{esPendiente && esAlumno ? (
				<label className={"pcPendiente" + (hecho ? " pcHecho" : "")}>
					<input type="checkbox" checked={hecho} disabled={ocupado || !marcar} onChange={alternar} aria-label={"Marcar como hecho: " + (post.title || "")} />
					<span style={{ minWidth: 0 }}><span className="pcTituloPost">{post.title}</span>{post.body ? <span className="pcCuerpo" style={{ display: "block", marginTop: 4 }}>{post.body}</span> : null}</span>
				</label>
			) : (
				<>
					{post.title ? <div className="pcTituloPost">{post.title}</div> : null}
					{post.body ? <p className="pcCuerpo">{post.body}</p> : null}
				</>
			)}
			{esEncuesta && post.poll ? <BloqueEncuestaVista api={api} post={post} poll={post.poll} esAlumno={esAlumno} onCambio={onCambio} /> : null}
			{esTarea && ficha ? (
				<>
					<div className="pcTareaDatos">
						<span className="pcChip pcChipAcento">{String(Math.round(ficha.points * 100) / 100)} Pts</span>
						{ficha.category ? <span className={"pcChip " + (ficha.categoryOk ? "pcChipBorde" : "pcChipOro")}>{ficha.categoryOk ? ficha.category : "Sin Categoría"}</span> : <span className="pcChip pcChipOro">Sin Categoría</span>}
						<span className="pcChip pcChipBorde">{ficha.deliveryLabel}</span>
						{ficha.dueLabel ? <span className="pcChip pcChipBorde">Vence {ficha.dueLabel}</span> : null}
						{esAlumno && ficha.mine && ficha.mine.state !== "pendiente" ? (
							<span className={"pcChip " + (ficha.mine.state === "atrasada" || ficha.mine.state === "cerrada" || ficha.mine.state === "repetir" ? "pcChipOro" : ficha.mine.state === "devuelta" ? "pcChipAcento" : "")}>
								{ficha.mine.state === "devuelta" && ficha.mine.score !== null ? String(Math.round(ficha.mine.score * 100) / 100) + " / " + String(Math.round(ficha.mine.pointsMax * 100) / 100)
									: ({ atrasada: "Atrasada", cerrada: "Cerrada", entregada: "Entregada", repetir: "Por Repetir", devuelta: "Calificada", en_clase: "Se Califica En Clase", lectura: "Solo Lectura", quiz: "Por Hacer" } as Record<string, string>)[ficha.mine.state] || ""}
							</span>
						) : null}
						{onAbrirTarea && ficha.delivery !== "sin_entrega" ? (
							<button type="button" className={"pcBtn pcBtnChico " + (esAlumno && ficha.delivery === "quiz" && ficha.mine?.state === "quiz" ? "pcBtnP" : "pcBtnS")} onClick={() => onAbrirTarea(post)}>
								{ficha.delivery === "quiz" ? (esAlumno ? "Abrir Quiz" : "Resultados") : esAlumno ? "Abrir Tarea" : "Calificar"}
							</button>
						) : null}
					</div>
					{ficha.rubric.length > 0 ? (
						<ul className="pcRubricaVista" aria-label="Rúbrica">
							{ficha.rubric.map((c, i) => <li key={i}><span>{c.name}</span><b>{String(Math.round(c.points * 100) / 100)} Pts</b></li>)}
						</ul>
					) : null}
				</>
			) : null}
			<ArchivosDeLaPublicacion api={api} archivos={post.files} esAlumno={esAlumno} />
			{post.status !== "publicada" ? null : <div className="pcPie">
				{post.views ? <span style={{ display: "inline-flex", gap: 6, alignItems: "center" }}><Icono n="ojo" size={16} />Visto Por {post.views.seen} De {post.views.total}</span> : null}
				{!esAlumno && esPendiente && post.todo ? <span style={{ display: "inline-flex", gap: 6, alignItems: "center" }}><Icono n="check" size={16} />Hecho Por {String(post.todo.done)} De {post.todo.total ?? 0}</span> : null}
				<button type="button" onClick={() => (abierto ? setAbierto(false) : verTodos())} aria-expanded={abierto}>
					<Icono n="burbuja" size={16} />{post.commentsCount === 0 ? "Comentar" : post.commentsCount === 1 ? "1 Comentario" : post.commentsCount + " Comentarios"}
				</button>
			</div>}
			{post.status === "publicada" && (lista.length > 0 || abierto) ? (
				<div className="pcComentarios">
					{!abierto && post.commentsCount > lista.length ? <button type="button" className="pcEnlaceBtn" onClick={verTodos}>Ver Los {post.commentsCount} Comentarios</button> : null}
					{lista.map((c) => <UnComentario key={c.id} c={c} onBorrar={() => borrarComentario(c.id)} />)}
					{puedeComentar && (abierto || lista.length > 0) ? (
						<form className="pcComentarioForm" onSubmit={(e) => { e.preventDefault(); enviar() }}>
							<label htmlFor={"com" + post.id} style={{ position: "absolute", left: -9999 }}>Escribe un comentario</label>
							<input id={"com" + post.id} className="pcInput" placeholder="Escribe Un Comentario" value={texto} maxLength={2000} onChange={(e) => setTexto(e.target.value)} />
							<button type="submit" className="pcBtn pcBtnP pcBtnChico" disabled={ocupado || texto.trim() === ""}>Enviar</button>
						</form>
					) : null}
				</div>
			) : null}
			{error ? <div className="pcAviso pcOro" role="alert">{error}</div> : null}
		</article>
	)
}

// ---------------------------------------------------------------- redactor (anuncio / material)

interface ArchivoEnRedactor { id?: number; key?: string; link?: string; name: string; mime?: string | null; size?: number }
interface PropsRedactor
{
	api: PortalApiPersonal
	modo: "anuncio" | "material" | "pendiente"
	unidades: UnidadPortal[]
	inicial?: PublicacionPortal | null
	onGuardado: (p: PublicacionPortal) => void
	onCancelar: () => void
}

export const Redactor: React.FC<PropsRedactor> = ({ api, modo, unidades, inicial, onGuardado, onCancelar }) => {
	const editando = !!inicial
	const [titulo, setTitulo] = useState<string>(inicial?.title || "")
	const [cuerpo, setCuerpo] = useState<string>(inicial?.body || "")
	const [unidad, setUnidad] = useState<string>(inicial?.unit ? String(inicial.unit.id) : "")
	const [fijar, setFijar] = useState<boolean>(!!inicial?.pinned)
	const [programar, setProgramar] = useState<string>(inicial?.status === "programada" ? (inicial.whenInput || aCampoFecha(inicial.whenMs)) : "")
	const [archivos, setArchivos] = useState<ArchivoEnRedactor[]>(inicial ? inicial.files.map((f) => ({ id: f.id, name: f.name, mime: f.mime, size: f.size, link: f.kind === "enlace" ? f.url || undefined : undefined })) : [])
	const [enlace, setEnlace] = useState<string>("")
	const [subiendo, setSubiendo] = useState<{ nombre: string; porciento: number } | null>(null)
	const [guardando, setGuardando] = useState<boolean>(false)
	const [error, setError] = useState<string | null>(null)
	const entrada = useRef<HTMLInputElement>(null)
	const tipo = inicial ? inicial.type : modo

	const agregarArchivos = async (lista: FileList | null) => {
		if (!lista) return
		setError(null)
		for (const f of Array.from(lista)) {
			if (archivos.length >= 10) { setError("Máximo 10 archivos por publicación."); break }
			if (f.size > 200 * 1024 * 1024) { setError("\"" + f.name + "\" pesa más de 200 MB."); continue }
			try {
				setSubiendo({ nombre: f.name, porciento: 0 })
				const key = await subirArchivo(api, f, "adjunto", (p) => setSubiendo({ nombre: f.name, porciento: p }))
				setArchivos((a) => [...a, { key, name: f.name, mime: f.type || null, size: f.size }])
			} catch (e) { setError(mensajeDeError(e, "No se pudo subir \"" + f.name + "\".")) }
		}
		setSubiendo(null)
		if (entrada.current) entrada.current.value = ""
	}
	const agregarEnlace = () => {
		const u = enlace.trim()
		if (!/^https?:\/\/\S+$/i.test(u)) { setError("El enlace debe empezar con http:// o https://."); return }
		let nombre = u
		try { nombre = new URL(u).hostname.replace(/^www\./, "") } catch { /* se queda la dirección */ }
		setArchivos((a) => [...a, { link: u, name: nombre }]); setEnlace(""); setError(null)
	}

	const publicar = async (borrador: boolean) => {
		if (guardando || subiendo) return
		setError(null)
		if ((tipo === "material" || tipo === "pendiente") && titulo.trim() === "") { setError("Ponle título " + (tipo === "material" ? "al material." : "al pendiente.")); return }
		if (cuerpo.trim() === "" && titulo.trim() === "" && archivos.length === 0) { setError("Escribe algo o adjunta un archivo."); return }
		setGuardando(true)
		const files: ArchivoNuevo[] = archivos.map((a) => a.id ? { id: a.id, name: a.name } : a.link ? { link: a.link, name: a.name } : { key: a.key, name: a.name, mime: a.mime, size: a.size })
		const datos = { type: tipo as "anuncio" | "material" | "pendiente", title: titulo.trim(), body: cuerpo.trim(), pinned: fijar, unitId: unidad ? Number(unidad) : null, publishAt: programar || null, draft: borrador, files }
		try { onGuardado(inicial ? await api.updatePost(inicial.id, datos) : await api.createPost(datos)) } catch (e) { setError(mensajeDeError(e)) } finally { setGuardando(false) }
	}

	return (
		<div className="pcTarjeta pcRedactor">
			<div className="pcFilaAutor">
				<span className="pcTituloPost" style={{ flex: 1 }}>{(editando ? "Editar " : "Nuevo ") + (tipo === "material" ? "Material" : tipo === "pendiente" ? "Pendiente" : "Anuncio")}</span>
				<button type="button" className="pcIb" aria-label="Cerrar" onClick={onCancelar}><Icono n="cerrar" /></button>
			</div>
			{tipo === "material" || tipo === "pendiente" ? (
				<div className="pcCampo">
					<label className="pcCampoEtiqueta" htmlFor="rdTitulo">Título</label>
					<input id="rdTitulo" className="pcInput" value={titulo} maxLength={200} onChange={(e) => setTitulo(e.target.value)} />
				</div>
			) : null}
			<div className="pcCampo">
				<label className="pcCampoEtiqueta" htmlFor="rdCuerpo">{tipo === "material" || tipo === "pendiente" ? "Descripción" : "Anuncio"}</label>
				<textarea id="rdCuerpo" className="pcTextarea" rows={tipo === "material" ? 3 : 4} value={cuerpo} maxLength={5000} placeholder={tipo === "anuncio" ? "Escribe Un Anuncio A Tu Clase" : ""} onChange={(e) => setCuerpo(e.target.value)} />
			</div>
			{archivos.length > 0 ? (
				<div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
					{archivos.map((a, i) => (
						<div className="pcAdjuntoFila" key={(a.id || a.key || a.link) + "-" + i}>
							<Icono n={a.link ? "enlace" : "doc"} /><span className="pcNombre">{a.name}</span>
							<button type="button" className="pcIb" style={{ width: 36, height: 36 }} aria-label={"Quitar " + a.name} onClick={() => setArchivos(archivos.filter((_, j) => j !== i))}><Icono n="cerrar" size={16} /></button>
						</div>
					))}
				</div>
			) : null}
			{subiendo ? (
				<div><div className="pcChico pcTenue">Subiendo {subiendo.nombre} {subiendo.porciento}%</div><div className="pcBarra"><div style={{ width: subiendo.porciento + "%" }} /></div></div>
			) : null}
			{tipo === "pendiente" ? <div className="pcAyuda">Un pendiente no lleva nota: el alumno lo marca como hecho (por ejemplo, "Traer filipina y gorro").</div> : null}
			<div className="pcRedactorBotones" style={tipo === "pendiente" ? { display: "none" } : undefined}>
				<input ref={entrada} type="file" multiple hidden onChange={(e) => agregarArchivos(e.target.files)} />
				<button type="button" className="pcBtn pcBtnS pcBtnChico" disabled={!!subiendo} onClick={() => entrada.current?.click()}><Icono n="clip" />Adjuntar Archivo</button>
				<input className="pcInput" style={{ flex: "1 1 200px", height: 40 }} aria-label="Enlace" placeholder="Pegar Enlace" value={enlace} onChange={(e) => setEnlace(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); agregarEnlace() } }} />
				<button type="button" className="pcBtn pcBtnS pcBtnChico" disabled={enlace.trim() === ""} onClick={agregarEnlace}><Icono n="enlace" />Agregar Enlace</button>
			</div>
			<div className="pcRedactorBotones">
				{unidades.length > 0 ? (
					<div className="pcCampo" style={{ flex: "1 1 200px" }}>
						<label className="pcCampoEtiqueta" htmlFor="rdUnidad">Unidad</label>
						<select id="rdUnidad" className="pcSelect" value={unidad} onChange={(e) => setUnidad(e.target.value)}>
							<option value="">Sin Unidad</option>
							{unidades.map((u) => <option key={u.id} value={u.id}>{u.name}</option>)}
						</select>
					</div>
				) : null}
				<div className="pcCampo" style={{ flex: "1 1 220px" }}>
					<label className="pcCampoEtiqueta" htmlFor="rdProgramar">Programar (Hora De México)</label>
					<input id="rdProgramar" type="datetime-local" className="pcInput" value={programar} onChange={(e) => setProgramar(e.target.value)} />
				</div>
			</div>
			<div className="pcRedactorPie">
				<label style={{ display: "inline-flex", gap: 8, alignItems: "center", fontWeight: 600, fontSize: 14.5, minHeight: 44 }}>
					<input type="checkbox" checked={fijar} onChange={(e) => setFijar(e.target.checked)} style={{ width: 20, height: 20, accentColor: "var(--pc-acento)" }} />Fijar Arriba
				</label>
				<div className="pcDerecha">
					<button type="button" className="pcBtn pcBtnS" disabled={guardando || !!subiendo} onClick={() => publicar(true)}>Guardar Borrador</button>
					<button type="button" className="pcBtn pcBtnP" disabled={guardando || !!subiendo} onClick={() => publicar(false)}>{programar ? "Programar" : editando ? "Guardar" : "Publicar"}</button>
				</div>
			</div>
			{error ? <div className="pcAviso pcOro" role="alert">{error}</div> : null}
		</div>
	)
}

/** Redactor simple del alumno cuando el muro está en "Alumnos Publican". */
export const RedactorAlumno: React.FC<{ api: PortalApi; yo: AutorPortal | null; onPublicado: (p: PublicacionPortal) => void }> = ({ api, yo, onPublicado }) => {
	const [texto, setTexto] = useState<string>("")
	const [ocupado, setOcupado] = useState<boolean>(false)
	const [error, setError] = useState<string | null>(null)
	const enviar = async () => {
		if (!texto.trim() || ocupado) return
		setOcupado(true); setError(null)
		try { onPublicado(await api.createPost({ type: "anuncio", body: texto.trim() })); setTexto("") } catch (e) { setError(mensajeDeError(e)) } finally { setOcupado(false) }
	}
	return (
		<form className="pcTarjeta" onSubmit={(e) => { e.preventDefault(); enviar() }}>
			<div className="pcFilaAutor">
				{yo ? <Avatar a={yo} size={36} /> : null}
				<label htmlFor="alPublicar" style={{ position: "absolute", left: -9999 }}>Escribe en el muro</label>
				<input id="alPublicar" className="pcInput" placeholder="Escribe Algo Para Tu Clase" maxLength={5000} value={texto} onChange={(e) => setTexto(e.target.value)} />
				<button type="submit" className="pcBtn pcBtnP pcBtnChico" disabled={ocupado || texto.trim() === ""}>Publicar</button>
			</div>
			{error ? <div className="pcAviso pcOro" role="alert">{error}</div> : null}
		</form>
	)
}
